module.exports = __webpack_public_path__ + "static/media/bg6.9d838a09.jpg";